export const nodeType = "AUDIO_EFFECT_EQ3";
